




















































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import SubscriptionPanel from '@/components/payment/SubscriptionPanel.vue';
import PaymentMethodManager from '@/components/payment/PaymentMethodManager.vue';
import User from '../models/User';
import copy from 'copy-to-clipboard';
import { VersionString } from '@/constants/environment';
import DemographicQuestionsForm from '@/components/user_questions/DemographicQuestionsForm.vue';

@Component(
    {
        components: {
            SubscriptionPanel,
            PaymentMethodManager,
            DemographicQuestionsForm
        },
    })
export default class ProfileView extends Vue
{
    tempUser : User | null = null;
    curTab : number = 0;
    editingEmail = false;
    busy = false;

    mounted()
    {
        this.tempUser = this.user;
    }

    copy(str : string)
    {
        copy(str);
    }

    editEmail()
    {
        this.editingEmail = true;
        this.tempUser = Object.assign(new User, this.user);
    }

    async saveEmail()
    {
        this.busy = true;
        try
        {
            if (this.tempUser != null)
            {
                const resp = await this.$http.put('userinfo', this.tempUser);
                this.editingEmail = false;
                if (resp.data.user && resp.data.user.email && resp.data.user.email === this.tempUser.email)
                {
                    this.user.email = resp.data.user.email;
                }
                else
                {
                    alert(`Email change request was received. Please check the inbox of the new email ${
                        (this.tempUser) ? this.tempUser.email : ''} for the verification email. Your email will remain unchanged until the new email is verified.`);
                }
            }
        }
        catch (er)
        {
            if (er.response)
            {
                if (er.response.status == 304)
                {
                    this.editingEmail = false;
                }
                else
                {
                    console.error(er.response.data.error);
                }
            }
            else
            {
                alert("Failed to update email");
            }
        }
        this.busy = false;
    }

    get isPureSSO()
    {
        return this.user.username.includes('@');
    }

    get expirationDisplay()
    {
        if (this.user.trialExpiration != null)
        {
            return this.user.trialExpiration.toLocaleString();
        }
        return '';
    }

    async updateUserQuestionForm()
    {
        let form = this.$refs.userQuestionForm as DemographicQuestionsForm;
        try
        {
            await form.submit();
        }
        catch(err)
        {
            console.error(err);
        }
    }

    get sourceUser()
    {
        return this.user;
    }

    get writeEmail()
    {
        if (this.tempUser == null)
        {
            return null;
        }
        return this.tempUser.email;
    }

    get VersionString() 
    {
        return VersionString; 
    }
}
